import React from 'react'
import { NavLink } from "react-router-dom";

function OneNavLink({colorIcon, url, title, icon, langLocal}) {
    return (
        <>
            <NavLink className="linkk" exact="true" to={url} >
                <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === url ? "active_menu_link" : ""}`}>
                    <div>
                        <i style={{color: `var(${colorIcon})`}} className={icon}></i>
                        <span> {title} </span>
                    </div>
                </div>
            </NavLink>
        </>
    )
}

export default OneNavLink